<template>
  <div>
    <div v-if="!$root.locked" class="oneui">
      <div></div>
      <div
        class="center-div"
        style="display: grid; position: fixed; width: 100vw; height: var(--top-padding)"
      >
        <div class="nameWrapper" style="grid-template-columns: 1fr">
          <div></div>
          <div class="current">
            <span>{{ $t("pages.rewards.title") }}</span>
          </div>
          <div></div>
        </div>
      </div>
      <div class="pageWrapper">
        <div class="page">
          <div id="choreContainer" class="cardContainer">
            <div>
<div class="card card-slim center-div" onclick="AddRewardModal.open()">
  <div class="card-header">
      <center>
        <h3>Create Custom Reward</h3><p>Create your own custom reward to motivate your child.
      </p></center>
    </div></div>              </div>
              <hr />
            </div>
            <div v-for="reward in rewards" :key="reward._getId()">
              <RewardListing
                :reward="reward"
                @activated="openModal(reward)"
              ></RewardListing>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.mileSelector {
  margin-top: calc(-1 * var(--page-padding-top));
}

input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.distWrapper {
  display: inline-block;
  position: relative;
  margin-top: 10px;
}

.pageWrapper {
  -webkit-transform: translate3d(0, 0, 0);
  -webkit-perspective: 1000;
  & > div {
    padding: var(--page-padding);
  }
}
#rewardModal {
  position: fixed;
}
</style>

<script>
/* NPM IMPORTS */
import LockScreen from "../../components/LockScreen";
import * as ModernModals from "modern-modals";

/* JS IMPORTS */
import * as CCDb from "../../utilities/db.js";
import stripe from "../../utilities/stripe.js";
import geo from "../../utilities/geo.js";
import randomId from "../../utilities/randomCode.js";
let modal;
export default {
  name: "Rewards",
  components: {
    LockScreen,
    RewardListing: () => import("../../components/RewardListing.vue"),
    RewardView: () => import("../../components/Layout/RewardView.vue"),
    //  KidsRewardView: () => import('../../components/Layout/KidsRewardView.vue')
  },
  data() {
    return {
      udt: true,
      rewards: [],
      message: null,
      currentReward: null,
      modal: null,
      isKidsView: false,
      selectedChild: null,
      path: null,
      reward: {
        name: "",
      },
    };
  },
  methods: {
    openModal(reward) {
      this.$data.reward = reward;
      this.$root.$data.currentReward = reward;
      this.$data.modal.open();
    },
  },
  async mounted() {
    this.$data.rewards = await CCDb.getRewards();
    this.$data.modal = new ModernModals.HTMLModal($_("AddSuggestedRewardModal"));
    window.suggestedRewardModal = this.$data.modal;
    await this.$nextTick();
  },
  beforeRouteLeave(to, from, next) {
    if (this.$data.isKidsView) VueInstance.locked = true;
    next();
  },
  async beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (from.path.split("/").includes("kids")) {
        vm.$data.isKidsView = true;
        vm.$data.selectedChild = from.query.ind;
        VueInstance.locked = false;
      }
      if (to.query.wasRequested) {
        setTimeout(async () => {
          console.clear();
          console.info(to.query.reward);
          const reward = await CCDb.getRecord("rewards", to.query.reward);
          if (reward) vm.openModal(reward);
        }, 1000);
      }
    });
  },
};
</script>
